import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import EcoFlowHero from "./components/EcoFlowHero";
import EcoFlowProducts from "./components/EcoFlowProducts";
import EcoFlowSpecs from "./components/EcoFlowSpecs";
import EcoFlowWhy from "./components/EcoFlowWhy";
import EcoFlowSignup from "./components/EcoFlowSignup";

export default function EcoFlowPage() {
  useEffect(() => {
    document.title = "EcoFlow Coming Soon — Iron Haven Supply | DELTA & RIVER Series Authorized Dealer";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Breadcrumb */}
      <div className="pt-[96px] bg-gray-950 border-b border-white/8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-amber-400 transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line text-gray-600"></i>
          <Link to="/authorized-brands" className="hover:text-amber-400 transition-colors cursor-pointer">Authorized Brands</Link>
          <i className="ri-arrow-right-s-line text-gray-600"></i>
          <span className="text-amber-400 font-medium">EcoFlow</span>
        </div>
      </div>

      <EcoFlowHero />
      <EcoFlowProducts />
      <EcoFlowWhy />
      <EcoFlowSpecs />
      <EcoFlowSignup />

      {/* Final CTA strip */}
      <section className="py-12 px-4 md:px-6 bg-amber-500">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-white font-extrabold text-xl">Ready to power your home with EcoFlow?</p>
            <p className="text-amber-100 text-sm mt-1">Sign up above and we&apos;ll notify you the moment we go live.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#ecoflow-signup"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("ecoflow-signup")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="flex items-center justify-center gap-2 bg-white hover:bg-amber-50 text-amber-600 font-bold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-bell-line text-sm"></i>
              </div>
              Get Early Access
            </a>
            <Link
              to="/shop"
              className="flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Browse Current Products
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
